export const news = {
  newsFeedCreateInputPlaceholder: 'Создать пост...',
  newsFeedSearchInputPlaceholder: 'Поиск',
  newsFeedPostOwnerCurtainEditTitle: 'Редактировать пост',
  newsFeedPostOwnerCurtainDeleteTitle: 'Удалить пост',
  newsFeedEditedPostSavedAlertText: 'Пост сохранен!',
  newsFeedEditedPostDeletedAlertText: 'Пост удален!',
  newsFeedShareCurtainOptionTitle: 'Скопировать ссылку',
  newsFeedPostLinkCopiedAlertText: 'Ссылка скопирована!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Скопировать ссылку',
  newsFeedOthersPosLinkCopiedAlertText: 'Ссылка скопирована!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Пожаловаться',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Удалить пост',
  newsFeedPostDeletePopupTitle: 'Удалить',
  newsFeedPostDeletePopupText: 'Удалить этот пост?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Отменить',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Подтвердить',
  newsFeedPostDeeletedAlertText: 'Пост удален!',
  newsPostDetailsHeaderTitle: 'Пост',
  postFeedPostLikesText: 'Нравится',
  postFeedPostCommentsText: 'Комментарии',
  postFeedPostNoLikesText: 'Пока нет лайков.',
  postFeedPostLeaveFirstLikeText: 'Оставьте первый лайк',
  newsFeedPostDetailsNoCommentsText: 'Пока нет комментариев',
  newsFeedPostDetailsFirstCommentText: 'Оставьте первый комментарий',
  newsFeedPostDetailsShareOptionTitle: 'Скопировать ссылку',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Ссылка скопирована!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Скопировать ссылку',
  newsFeedPostDetailsCopiedAlertText: 'Ссылка скопирована!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Пожаловаться',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Пожаловаться',
  newsPostDetailsReportedCurtainText: 'Жалоба отправлена',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Редактировать комментарий',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Удалить комментарий',
  newsPostDetailsEditedCommentSavedAlertText: 'Комментарий сохранен!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Удалить комментарий',
  postDetailsOtherUsersCommentDeletadAlertText: 'Комментарий удален!',
  postDetailsDeleteCommentPopupTitle: 'Удалить',
  postDetailsDeleteCommentPopupText: 'Удалить этот комментарий?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Отменить',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Подтвердить',
  postDetailsCommDeletedAlertText: 'Комментарий удален!',
  postDetailsCommentUserCurtainOptionTitle: 'Пожаловаться на комментарий',
  newsCreatePostCurtainTitle: 'Новый пост',
  newsCreatePostCurtainBodyPlaceholder: 'Начните писать здесь...',
  newsCreatePostPublishButtonTitle: 'Опубликовать',
  newsCreatePostUploadSlallerImageAlertText: 'Вы не можете загружать больше {size} MB за раз',
  newsPostSavedAlertText: 'Пост сохранен!',
  newsCreatePostAddLocationCurtainTitle: 'Локация',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Название локации',
  newsCreatePostEditLocationCurtainText: 'Редактировать локацию',
  newsDeleteLocation: 'Удалить локацию',
  newsDiscardPostPopupTitle: 'Черновик',
  newsDiscardPostPopupText: 'Удалить черновик?',
  newsDiscardPostPopupCancelButtonTitle: 'Отменить',
  newsDiscardPostPopupCofirmButtonTitle: 'Подтвердить',
  newsNewPostCreatePollTitle: 'Создать опрос',
  newsNewPostCreatePollTitleInputPlaceholder: 'Название',
  newsNewPostCreatePollOptionInputPlaceholder: 'Вариант',
  newsNewPostCreatePollAddButtonTitle: 'Добавить вариант',
  newsNewPostCreatePollCreateButtonTitle: 'Создать',
  newsCreatePostPollTitleBlankAlertText: 'Заполните поле!',
  newsCreatePostPollOptionBlankAlertText: 'Заполните поле!',
  newsCreatePostPollLongTitleAlertText: 'Слишком длинное название, выберите не более {length} символов',
  newsCreatePostPollLongOptionAlertText: 'Слишком длинный вариант, выберите не более {length} символов',
  newsCreatePostPollEditOptionTitle: 'Редактировать опрос',
  newsCreatePostPollRemoveOptionTitle: 'Удалить опрос',
  newsPostPollInfoVotesText: 'голосов',
  newsPostPollInfoEditVoteText: 'Переголосовать',
  newsPostPollFinishPollText: 'Завершить',
  newsPostPollFinishedPollText: 'Завершено',
  newsPostPollInProgresslText: 'В процессе',
  newsFinishPollCurtainTitle: 'Завершить',
  newsFinishPollCurtainText: 'Пользователи больше не смогут голосовать в этом опросе, когда он будет завершен.',
  newsFinishPollCurtainCancelButtonTitle: 'Отменить',
  newsFinishPollCurtainConfirmlButtonTitle: 'Подтвердить',
  newsPollInfoPollVotesCurtainTitle: 'Голоса',
  newsEditPostCurtainTitle: 'Редактировать пост',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Начните писать здесь...',
  newsEditPostCurtainSaveButtonTitle: 'Сохранить',
  newsEditPostSavedAlertText: 'Пост сохранен!',
  newsError: 'Что-то пошло не так!',
  newsAt: 'в',
  newsSeeMore: 'Развернуть...',
  newsMaxAttachments: 'Вы превысили максимальное количество фотографий. Максимальное количество составляет {max} фото',
  newsReply: 'Ответить',
  newsPin: 'Закрепить пост',
  newsUnpin: 'Открепить пост'
}
